import { render } from "./StaticNav.vue?vue&type=template&id=9dd45e10&scoped=true&ts=true"
import script from "./StaticNav.vue?vue&type=script&lang=ts"
export * from "./StaticNav.vue?vue&type=script&lang=ts"

import "./StaticNav.vue?vue&type=style&index=0&id=9dd45e10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd45e10"]])

export default __exports__